// extracted by mini-css-extract-plugin
export default {"container":"YjTc_lNTfFKRI1syyIUj"};